import React, { memo, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { postAPI } from "../../../config/api/apiConfig";
import { Button, Form, Input, Upload, message, Row, Col } from "antd";
import { useSelector } from "react-redux";

const ProcessDeviceMultipleFiles = memo(({
  listedDeviceId,
  status,
  organisationName,
  deviceName,
  refreshDevices
}) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const userId = useSelector((state) => state.authenticate.userId);

  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
  };

  const handleFileChange = (info) => {
    const newFileList = info.fileList.map((file) => file.originFileObj);
    setFileList(newFileList);
  };

  const validateFiles = () => {
    const allowedFileTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    const fileTypeCount = {};

    for (const file of fileList) {
      if (!allowedFileTypes.includes(file.type)) {
        message.error('Only PDF, Word, and Excel files are allowed.');
        return false;
      }

      const fileType = file.type;
      if (fileTypeCount[fileType]) {
        message.error('You cannot upload more than one file of the same type.');
        return false;
      } else {
        fileTypeCount[fileType] = 1;
      }
    }

    if (fileList.length === 0) {
      message.error('Please upload at least one file.');
      return false;
    }

    return true;
  };

  const onFinish = async (values) => {
    if (!validateFiles()) {
      return;
    }

    try {
      setLoading(true);

      const { adminRemarks, deviceId, createdBy } = values;
      const formData = new FormData();
      formData.append("adminRemarks", adminRemarks);
      formData.append("deviceId", parseInt(deviceId));
      formData.append("createdBy", parseInt(createdBy));

      for (let i = 0; i < fileList.length; i++) {
        formData.append("deviceReportPaths", fileList[i]);
      }

      const folderName = `${organisationName}/${deviceName}`;
      const url = `/upload-multiple-reports?folderName=${folderName}`;
      const response = await postAPI(url, formData);

      message.success("Device processed successfully");
      form.resetFields();
      setLoading(false);
      setFileList([]);
      refreshDevices();
    } catch (error) {
      setLoading(false);
      message.error(`${error.response?.data?.message || 'Error processing device'}`);
      form.resetFields();
    }
  };

  return (
    <Form
      form={form}
      name="validate_other"
      {...formItemLayout}
      onFinish={onFinish}
      initialValues={{
        "input-number": 3,
        "checkbox-group": ["A", "B"],
        rate: 3.5,
      }}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 24 }}
      layout="vertical"
    >
      <Form.Item
        name="adminRemarks"
        label="Admin Remark"
        rules={[
          {
            required: true,
            message: "Please input Intro",
          },
        ]}
      >
        <Input.TextArea showCount maxLength={500} rows={4} cols={40} />
      </Form.Item>
      <Form.Item
        name="deviceId"
        label="Device ID"
        style={{ display: "none" }}
        initialValue={parseInt(listedDeviceId)}
      >
        <Input value={parseInt(listedDeviceId)} />
      </Form.Item>

      <Form.Item
        name="createdBy"
        label="Created By"
        style={{ display: "none" }}
        initialValue={parseInt(userId)}
      >
        <Input value={parseInt(userId)} />
      </Form.Item>

      <Form.Item
        label="Report(s)"
        name="deviceReportPaths"
        rules={[
          {
            required: true,
            message: "Please upload device report(s)",
          },
        ]}
      >
        <Upload.Dragger
          name="file"
          multiple
          onChange={handleFileChange}
          beforeUpload={() => false}
        >
          <Row>
            <Col xs={24} sm={8} md={8} lg={8}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
            </Col>
            <Col xs={24} sm={16} md={24} lg={24}>
              <p className="ant-upload-text" style={{fontSize: "1em", padding: "1em"}}>
                Attached files include processed application vetted by the admin
              </p>
              <p className="ant-upload-hint">
                Please attach all necessary documents
              </p>
            </Col>
          </Row>
        </Upload.Dragger>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
});

export default ProcessDeviceMultipleFiles;
